<div class="layout-wrapper" [ngClass]="containerClass" [class]="sidebarClass">
    <div class="layout-content-wrapper">
        <app-topbar></app-topbar>
        <div class="layout-content">
            <div *ngIf="impersonnationBannerInfo" class="col-12">
                <p-messages severity="info" [closable]="false">
                    <ng-template pTemplate>
                        <i class="pi pi-info-circle"></i>
                      <div class="ml-2">
                        <strong>{{'usurpation-cnx.mode-navigation' | translate}}</strong> {{'usurpation-cnx.text1' | translate}} <strong>{{impersonnationBannerInfo.username}}</strong>{{'usurpation-cnx.text2' | translate}}
                        <a (click)="exitImpersonation()" class="text-color cursor-pointer"><span class="underline font-bold">{{'usurpation-cnx.text3' | translate}}</span></a>.
                      </div>
                    </ng-template>
                </p-messages>
            </div>
          <div *ngIf="allContractsAreDesactivated" class="col-12">
            <p-messages severity="warn" [closable]="false">
              <ng-template pTemplate>
                <i class="pi pi-info-circle"></i>
                  <div class="ml-2" *ngIf="!resilWithYear">
                      <strong>{{'all-contracts-desactivated.title' | translate}}</strong><strong></strong>{{'all-contracts-desactivated.text-month' | translate: {desactivationDelay:desactivationDelayWithMonth} }}
                  </div>
                  <div class="ml-2" *ngIf="resilWithYear">
                      <strong>{{'all-contracts-desactivated.title' | translate}}</strong><strong></strong>{{'all-contracts-desactivated.text-years' | translate: {desactivationDelay:desactivationDelayWithYears} }}
                  </div>
              </ng-template>
            </p-messages>
          </div>
            <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
    <app-faq-shortcut></app-faq-shortcut>
    <app-nous-contacter-shortcut></app-nous-contacter-shortcut>
    <app-search></app-search>
    <app-rightmenu></app-rightmenu>
    <app-cookie-consent *ngIf="isConsentVerificationEnabled"></app-cookie-consent>
    <div class="layout-mask"></div>
</div>
